//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Image,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  MessageBox,
} from 'element-ui';
import { Time } from 'lib-utils';
import { mapGetters, mapMutations } from 'vuex';
import ImageItem from '../public/image-item.vue';
import ReviewDialog from '../moments/review-dialog.vue';
import ItemShare from './item-share';
import PostCommentItem from './post-comment-item.vue';
import * as types from '@/types';
import VideoPlayer from '@/components/video-player';
import { unfollow, delMyPost } from '@/api/user';
import { addFavorite, removeFavorite } from '@/api/hotpost';
import { GetBatchQueryAdjust } from '@/api/portfolio';
import { deleteDynamic } from '@/api';
import { FILE_ICONS, MomentRoleIcons } from '@/constants/index';
import { formatCommit, secondFormat } from '~/utils';
import { linkPage } from '~/utils/util';
import BtnFollow from '~/components/public/btn-follow';
import ComplaintDialog from '~/components/public/violation/complaint-dialog.vue';
import MessageDialog from '~/components/public/violation/message-dialog.vue';
import ImageViewer from '~/components/public/image-viewer.vue';
import {
  PutMomentContentStickTop,
  PutMomentContentEssence,
  IgnoreQuestion,
  reviewCheckSensitive,
} from '@/api/moments';
export default {
  name: 'GPostItem',
  components: {
    ElImage: Image,
    ElDialog: Dialog,
    ElDropdown: Dropdown,
    ElDropdownItem: DropdownItem,
    ElDropdownMenu: DropdownMenu,
    ElImageViewer: ImageViewer,
    VideoPlayer,
    ItemShare,
    BtnFollow,
    ComplaintDialog,
    MessageDialog,
    ImageItem,
    PostCommentItem,
    ReviewDialog,
  },
  filters: {
    commonTime: v => {
      return Time.FormatCommon(v).join(' ');
    },
  },
  provide() {
    return {
      PostItemData: this.data,
      isLink: this.isLink,
    };
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    showFollowBtn: {
      type: Boolean,
      default: true,
    },
    isAbbreviation: {
      // 标题和文本是否缩略
      type: Boolean,
      default: true,
    },
    titleAbbreviationLineCount: {
      type: Number,
      default: 2,
    },
    type: {
      // 动态类型
      type: String,
      default: null,
    },
    isLink: {
      // 判断是否跳转页面
      type: Boolean,
      default: true,
    },
    isShowComment: {
      // 是否展示评论
      type: Boolean,
      default: true,
    },
    likeLayout: {
      // 点赞布局类型
      type: String,
      default: 'share,like,comment,readCount',
    },
    maxCommentCount: {
      type: Number,
      default: 1,
    },
    // 隐藏模块
    hideModules: {
      type: Array,
      default: () => [],
    },
    // 展示圈子路由小标签
    isShowMomentTag: {
      type: Boolean,
      default: false,
    },
    // 展示右上角 action 区域
    showAllAction: {
      type: Boolean,
      default: true,
    },
    // 评论是否不跳转
    isLocalComment: {
      type: Boolean,
      default: false,
    },
    // 是否为首席圈内容
    isChiefGroup: {
      type: Boolean,
      default: false,
    },
    // 是否为放大弹窗图片预览
    isOverImageView: {
      type: Boolean,
      default: true,
    },
    // 是否为预览内容
    isPreview: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: String,
      default: 'community',
    },
  },
  data() {
    return {
      momentRoles: {
        OWNER: '圈主',
        HONORED_GUEST: '嘉宾',
      },
      defaultAvatar:
        'https://img4.gelonghui.com/headdefault/avatar_default2.png',
      formatCommit,
      secondFormat,
      linkPage,
      dialogShow: false,
      showViewer: false,
      previewSrcList: [],
      videoDialog: {
        visible: false,
        src: null,
        poster: null,
      },
      messageData: {
        show: false,
        content: '提交成功',
      },
      adjustData: {},
      query: {},
      hotPostImage: ['http://res.gelonghui.com/images/logo_share4dynamic.png'], // 转发动态没图片时的默认图片
      isStickTop: !!this?.data?.moment?.isStickTop, // 默认值初始化
      isExpandContent: false,
      isShowExpand: false,
      reviewDialog: {
        content: null,
        refId: null,
        source: 'dynamic',
        show: false,
      },
    };
  },
  computed: {
    ...mapGetters('user', ['isFollow', 'isLogin', 'userId', 'loginInfo']),
    /**
     * @description 用户信息对象
     */
    userInfo() {
      const baseObj = {
        avatar: this.defaultAvatar,
        nick: '用户昵称',
        svip: null,
      };
      const obj = Object.assign(baseObj, this.data.user || {});

      return obj;
    },
    regionName() {
      return this.data?.regionName || null;
    },
    /**
     * @description 文章时间
     */
    postTimestamp() {
      let timestamp = new Date();
      timestamp = parseInt(timestamp.getTime() / 1000);
      const t =
        this.data.displayTimestamp || this.data.createTimestamp || timestamp;
      if (!this.isMoment) {
        return this.$options.filters.formatTime(t);
      } else {
        return Time.FormatCommon(t * 1000).join(' ');
      }
    },
    dynamicCount() {
      return this.data.dynamicCount || {};
    },
    /**
     * @description 动态转发至社区默认内容
     */
    defaultContent() {
      let text = '';
      if (this.data.sharedThings) {
        const { nick, id } = this.data.user;
        text = `//<[@${nick},${id}]>：${this.data.content}`;
      }
      return text;
    },
    comments() {
      const comments = this.data.comments || [];
      // 返回最大条数
      return comments.slice(0, this.maxCommentCount);
    },
    // 非首席圈动态才显示SVIP icon
    showSVIPIcon() {
      return (
        this.userInfo.svip &&
        this.userInfo.membership &&
        this.userInfo.svip.expireTimestamp * 1000 >= new Date().getTime() &&
        !this.data.moment
      );
    },
    // 获取首席圈 moment
    momentRole() {
      const role = this.data?.moment?.authorRole;
      return {
        role,
        roleIcon: MomentRoleIcons[role],
      };
    },
    files() {
      const files = (this.data?.files || []).map(item => {
        return {
          ...item,
          icon: FILE_ICONS[item.extension] || FILE_ICONS['unknown'],
        };
      });
      return files;
    },
    showEssentialIcon() {
      return this.data?.moment?.isEssential === true;
    },
    // 展示圈主操作 并且不是提问 并且审核通过
    showMomentOwner() {
      return (
        this.data?.moment?.userRole === 'OWNER' &&
        !this.data?.question &&
        this.data.reviewStatus === 'approved'
      );
    },
    // 圈子ID
    momentId() {
      return this.data?.moment?.momentId || '';
    },
    // 展示忽略action 未回答才有忽略
    showIgnoreAction() {
      return (
        !!this.data?.question &&
        this.data?.question?.answerUserId === this.userId &&
        !this.data?.question?.answerRoute
      );
    },
    // 是精华
    isEssential() {
      return this.data?.moment?.isEssential === true;
    },
    // 是圈子
    isMoment() {
      return !!this.data?.moment;
    },
    // 如果没有圈子权限不给看预览图
    newPreviewSrcList() {
      if (this.isMoment) {
        if (this.data.moment.userRole) {
          return this.data?.pictureUrls ?? [];
        } else {
          return [];
        }
      } else {
        return this.data.pictureUrls ?? [];
      }
    },
  },
  mounted() {
    // 这个蛇皮操作是防止 a 标签点击事件冒泡的
    const elem = this.$refs.postItem;
    if (!elem) return;
    const aTag = elem.getElementsByClassName('link');
    if (aTag) {
      for (const item of aTag) {
        item.onclick = e => {
          e.stopPropagation(); // 阻止冒泡
        };
      }
    }
    this.getAdjust();
    this.$nextTick(() => {
      this.isShowMoreContent();
    });
  },
  methods: {
    ...mapMutations('user', {
      show: types.SHOW_LOGIN_FORM,
      unFollowStatus: types.UNFOLLOW,
    }),
    /**
     * @description 查看更多内容
     */
    isShowMoreContent() {
      const el = this.$refs.postContent;
      if (el) {
        const { scrollHeight, clientHeight } = el;
        if (scrollHeight > clientHeight && !this.isPreview) {
          this.isShowExpand = true;
        }
      }
    },
    /**
     * @description 格式化被转发的动态或文章内容
     * @returns { string } 格式化文案
     */
    formatText(content) {
      let text = '';
      const { authorNick } = this.data.sharedThings;
      if (authorNick) {
        text = `<span class="share-nick">@${authorNick}：</span>`;
      }
      text += formatCommit(content);
      return text;
    },
    openVideo() {
      document.body.style.overflow = 'hidden';
      this.videoDialog = {
        visible: true,
        src: this.data.video.videoUrl,
        poster: this.data.video.thumbnailUrl,
      };
    },
    dialogCannel() {
      document.body.style.overflow = 'auto';
      this.videoDialog = {
        visible: false,
        src: null,
        poster: null,
      };
    },
    /**
     * @description 没有评论时展示输入框，有评论不展示，直接跳转
     */
    clickComment() {
      if (this.data.closeComment) {
        this.messageData.show = true;
        this.messageData.content = '该内容已限制评论';
        return;
      }
      if (
        this.data.comments &&
        this.data.comments.length > 0 &&
        !this.isLocalComment
      ) {
        this.handleClick();
      } else {
        this.$emit('clickComment', this.data);
      }
    },
    /**
     * @description 点赞状态改变
     */
    changeLike() {
      if (this.data.like) {
        this.dynamicCount.likeCount--;
      } else {
        this.dynamicCount.likeCount++;
      }
      this.data.like = !this.data.like;
    },
    /**
     * @description 点击热区跳转
     */
    handleClick() {
      if (this.isLink) {
        this.linkPage(this.data.route);
      }
    },
    changeFollow() {
      if (this.data.user) {
        this.data.user.isFollow = !this.data.user.isFollow;
      }
    },
    /**
     * @description 下拉菜单
     */
    handleCommand(command) {
      if (!this.isLogin) {
        this.show(false);
        return false;
      }
      switch (command) {
        case 'setIgnored':
          MessageBox.confirm(
            '确定忽略该提问吗？忽略后将从列表移除，不可找回?',
            '忽略动态',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          ).then(() => {
            this.handleMomentAction('setIgnored');
          });
          break;
        case 'setStickTop':
          this.handleMomentAction('setStickTop');
          break;
        case 'rmStickTop':
          this.handleMomentAction('rmStickTop');
          break;
        case 'setEssential':
          this.handleMomentAction('setEssential');
          break;
        case 'collect':
          this.handleCollect();
          break;
        case 'complaint':
          this.query = {
            id: this.data.id,
            source:
              this.type === 'activity'
                ? 'dynamic'
                : this.type === 'article'
                ? 'article'
                : null,
            type: 'content',
            userId: this.data && this.data.user.id,
          };
          this.dialogShow = true;
          break;
        case 'cancelFollow':
          this.cancelFollow();
          break;
        case 'delete':
          this.handleDelete();
          break;
        case 'review':
          this.handleReview();
          break;
        default:
          break;
      }
    },
    /**
     * @description 审核弹窗
     */
    async handleReview() {
      const query = {
        source: this.data.sourceType,
        refId: this.data.id,
      };
      const data = await this.$axios(reviewCheckSensitive(query));
      if ([2024, 200].includes(data.statusCode)) {
        let content = null;
        if (data.statusCode === 2024) {
          content = data.result;
        }
        this.reviewDialog = {
          content,
          refId: this.data.id,
          source: this.data.sourceType,
          show: true,
        };
      } else {
        this.messageData.show = true;
        this.messageData.content = data.message;
      }
    },
    handleReviewClose() {
      this.reviewDialog = {
        content: null,
        refId: null,
        source: 'dynamic',
        show: false,
      };
    },
    handleReviewSuccess() {
      this.messageData.show = true;
      this.messageData.content = '内容审核已通过';
      this.data.reviewStatus = 'approved';
    },
    handleReviewError(err) {
      this.messageData.show = true;
      this.messageData.content = err;
    },
    async handleCollect() {
      const [refId, source] = [
        this.data.id,
        this.type === 'activity'
          ? 'dynamic'
          : this.type === 'article'
          ? 'article'
          : null,
      ];
      let data = null;
      if (this.data.favorite) {
        data = await this.$axios(removeFavorite(refId, source));
      } else {
        data = await this.$axios(addFavorite({ refId, source }));
      }
      if (data.statusCode === 200) {
        this.data.favorite = !this.data.favorite;
      }
    },
    /**
     * @description 取消关注
     */
    async cancelFollow() {
      const data = await this.$axios(
        unfollow({
          id: this.userInfo.id,
        })
      );
      if (data.statusCode === 200) {
        this.unFollowStatus(this.userInfo.id);
        this.data.user.isFollow = !this.data.user.isFollow;
      }
    },
    /**
     * @description 关闭投诉弹窗
     */
    closeComplaint() {
      this.showMore = false;
      this.dialogShow = false;
    },
    /**
     * @description 删除
     */
    handleDelete() {
      MessageBox.confirm('此操作将删除该动态, 是否继续?', '删除动态', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data =
          this.data.sourceType === 'article'
            ? await this.$axios(delMyPost({ postId: this.data.id }))
            : await this.$axios(deleteDynamic(this.data.id));
        if (data.statusCode === 200) {
          this.$emit('deletePost');
        }
      });
    },
    /**
     * @description 获取调仓记录
     */
    async getAdjust() {
      if (
        !this.data.portfolios ||
        !this.data.portfolios[0] ||
        !this.data.adjustTimestamp
      )
        return;
      const res = await this.$axios(
        GetBatchQueryAdjust({
          params: [
            {
              portfolioCode: this.data.portfolios[0],
              timestamp: this.data.adjustTimestamp,
            },
          ],
        })
      );
      if (res.result && res.result.length > 0) {
        this.$set(this, 'adjustData', res.result[0]);
      }
    },
    /**
     * @description 动态内容点击事件 查看图片
     * @param {*} e
     */
    previewImageHandle(e) {
      if (
        e.target.getAttribute('image-url') ||
        e.target.parentNode.getAttribute('image-url')
      ) {
        this.previewSrcList = [
          e.target.getAttribute('image-url') ||
            e.target.parentNode.getAttribute('image-url'),
        ];
        this.showViewer = true;
      }
    },
    async handleMomentAction(type) {
      const momentId = this.data?.moment?.momentId;
      const dynamicId = this.data?.id;
      let config;
      switch (type) {
        case 'setStickTop':
          config = PutMomentContentStickTop({
            dynamicId,
            momentId,
            top: true,
          });
          break;
        case 'rmStickTop':
          config = PutMomentContentStickTop({
            dynamicId,
            momentId,
            top: false,
          });
          break;
        case 'setEssential':
          config = PutMomentContentEssence({
            dynamicId,
            momentId,
            essence: !this.isEssential,
          });
          break;
        case 'setIgnored':
          config = IgnoreQuestion(dynamicId);
          break;
        default:
          this.$messagebox.show(
            { title: '出错', describe: '参数异常' },
            { cb: () => {}, buttonName: ['确定'] }
          );
          return;
      }

      const [err, data] = await this.$http(config);
      if (err) {
        this.$messagebox.show(
          { title: '系统错误', describe: err.message || '请求数据失败' },
          { cb: () => {}, buttonName: ['确定'] }
        );
        return;
      }
      if (data.statusCode === 200) {
        this.$emit('momentAction');
        if (type.includes('StickTop')) {
          this.isStickTop = !this.isStickTop;
        }
        this.$messagebox.show(
          { title: '系统提示', describe: '操作成功' },
          {
            cb: () => {
              // this.momentOwnerActionSuccess();
            },
            buttonName: ['确定'],
          }
        );
      } else {
        this.$messagebox.show(
          {
            title: '系统错误',
            describe: `操作失败:${data.message} ${data.statusCode}`,
          },
          { cb: () => {}, buttonName: ['确定'] }
        );
      }
    },
    // 下载文件
    downLoadFile(file) {
      if (!this.isLink) return;
      const x = new XMLHttpRequest();
      x.open('GET', file.url, true);
      x.responseType = 'blob';
      x.onload = function () {
        const u = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = u;
        a.download = file.name;
        a.target = '_blank';
        a.click();
      };
      x.send();
    },
    handleCommentSuccess(res) {
      this.data.comments = this.data.comments || [];
      this.data.comments.unshift(res);
    },
    handleCommentDelete(index) {
      this.data.comments.splice(index, 1);
    },
  },
};
